<template>
  <div class="card mb-3">
    <div class="card-body">
      <div v-if="loading">
        <loading-spinner />
      </div>
      <div v-else-if="chartData.length">
        <apexchart
          type="line"
          height="250"
          :options="chartOptions"
          :series="chartSeries"
        />
      </div>
      <div v-else>
        <div class="alert alert-info">No data.</div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, defineAsyncComponent, defineProps} from 'vue'
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";

const apexchart = defineAsyncComponent(() =>
  import('vue3-apexcharts').then(module => module.default || module)
)

const props = defineProps({
  rawData: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const chartData = computed(() => {
  return [...props.rawData].sort((a, b) => new Date(a.day_date) - new Date(b.day_date))
})

const maxInteractionCount = computed(() =>
  Math.max(0, ...chartData.value.map(row => row.interaction_count))
)

const maxEshopCount = computed(() =>
  Math.max(1, ...chartData.value.map(row => row.eshop_count))
)

const chartSeries = computed(() => [
  {
    name: 'Eshops',
    type: 'column',
    data: chartData.value.map(row => row.eshop_count)
  },
  {
    name: 'Interactions',
    type: 'line',
    data: chartData.value.map(row => row.interaction_count)
  }
])

const chartOptions = computed(() => ({
  chart: {
    toolbar: { show: false },
    animations: { enabled: true },
    zoom: { enabled: false }
  },
  title: {
    text: 'App Usage'
  },
  plotOptions: {
    bar: {
      columnWidth: '80%',
      borderRadius: 2
    }
  },
  stroke: {
    width: [0, 3]
  },
  xaxis: {
    categories: chartData.value.map(row => new Date(row.day_date).toLocaleDateString()),
    labels: {
      rotate: -45,
      style: { fontSize: '10px' }
    }
  },
  yaxis: [
    {
      min: 0,
      max: maxEshopCount.value,
      tickAmount: Math.min(maxEshopCount.value, 10),
      title: { text: 'Eshops' },
      labels: {
        formatter: (val) => Math.round(val)
      }
    },
    {
      opposite: true,
      min: 0,
      max: maxInteractionCount.value + 5,
      title: { text: 'Interactions' },
      labels: {
        formatter: (val) => Math.round(val)
      }
    }
  ],
  grid: {
    borderColor: '#e0e0e0',
    strokeDashArray: 4
  }
}))

</script>

<style lang="scss" scoped>

</style>
